import {OptionType} from "src/types/OptionType";



export const BANNER_PLACEMENTS: OptionType[] = [
  {key: "profile", value: "Профиль"},
  {key: "calendar", value: "Календарь"},
  {key: "prepayment", value: "Аванс"},
];

export const BANNER_PLATFORMS: OptionType[] = [
  {key: "android", value: "Android"},
  {key: "ios", value: "iOS"},
  {key: "web", value: "Web"},
];

export const BANNER_STATUSES: OptionType[] = [
  {key: "active", value: "Активен"},
  {key: "inactive", value: "Неактивен"},
  {key: "scheduled", value: "Запланирован"},
  {key: "expired", value: "Истёк"},
];


export const BANNER_EMPLOYMENT_STATUSES: OptionType[] = [
  {key: "GUEST", value: "Гость"},
  {key: "UNREGISTERED", value: "Не оформлен"},
  {key: "UNSIGNED_PDOCS", value: "Не подписаны документы"},
  {key: "ACTIVE", value: "Активен"},
  {key: "FIRED", value: "Уволен"},
];

// meta не типизирован (Record<string, any>) — достаём справочник статусов
// защитно по нескольким вероятным ключам, иначе fallback-константа
export const extractEmploymentStatuses = (
  meta?: Record<string, any>,
): OptionType[] => {
  const raw =
    meta?.employmentStatuses ??
    meta?.employment_statuses ??
    meta?.statuses;

  if (Array.isArray(raw) && raw.length) {
    return raw.map((it: any) =>
      typeof it === "string"
        ? {key: it, value: it}
        : {key: String(it.key ?? it.value), value: String(it.value ?? it.key)},
    );
  }

  return BANNER_EMPLOYMENT_STATUSES;
};

export const bannerLabel = (options: OptionType[], key?: string): string =>
  options.find((it) => it.key === key)?.value ?? key ?? "";


const BANNER_PROJECT_ERRORS: OptionType[] = [
  {
    key: "allProjects and projectIds cannot be used together",
    value: "Нельзя одновременно выбрать «Все проекты» и конкретные проекты",
  },
  {
    key: "projectIds are required when allProjects is false",
    value: "Выберите хотя бы один проект или вариант «Все проекты»",
  },
  {
    key: "one or more projects do not exist",
    value:
      "Один или несколько выбранных проектов больше не существуют — уберите их из списка",
  },
];

export const bannerProjectError = (raw?: string | null): string | null => {
  if (!raw) return null;
  const normalized = raw.toLowerCase();
  return (
    BANNER_PROJECT_ERRORS.find((it) =>
      normalized.includes(it.key.toLowerCase()),
    )?.value ?? null
  );
};

export const BANNER_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const BANNER_IMAGE_ACCEPT = ["image/png", "image/jpeg", "image/webp"];
